import moment from 'moment';
import { JsonWorkDayModel, WorkdayModel, WorkdayModelFromJson } from '../low-level/workday.model';

export class WorkWeekdayModel {
    public workdayModelList: WorkdayModel[] = [];
    public currentWeek: number;
    public constructor(data: WorkdayModel[], currentWeek?: number) {
        this.workdayModelList = data;
        if (typeof currentWeek === 'undefined') {
            this.currentWeek = moment().isoWeek();
            return;
        }
        this.currentWeek = currentWeek;
    }
}

export class WorkWeekdayModelFromJson extends WorkWeekdayModel {
    public constructor(data: JsonWorkWeekdayModel) {
        super(
            data.workdayModelList
                ? data.workdayModelList.map((jsonWorkDayModel) => new WorkdayModelFromJson(jsonWorkDayModel))
                : [],
            data.currentWeek,
        );
    }
}

export interface JsonWorkWeekdayModel {
    workdayModelList: JsonWorkDayModel[];
    currentWeek: number;
}
